<template>
  <layout-block :has-border="false" :width="width" margin="48px 16px">
    <layout-block-head :title="radar.title" />
    <template>
      <img
        src="https://gatoreviews.s3.eu-west-3.amazonaws.com/common/emails/new/radar-screenshot.png"
        width="90%"
        style=" margin: 32px 0; border: 5px solid white;border-radius:50%; box-shadow : 0 10px 15px rgba(0,0,0,.12); max-width:400px;"
      />
      <layout-block-section margin="0">
        <template v-for="(r, idx) in radar.data">
          <layout-block-title
            :title="r.title"
            :icon="r.title_icon_url"
            :font-weight="500"
            :center="false"
            font-size="18px"
            color="#06152F"
            :key="`radar-title-${idx}`"
          />
          <layout-block-separator v-if="idx + 1 < radar.data.length" :key="`radar-separator-${idx}`" />
        </template>
      </layout-block-section>
    </template>
    <ui-button :label="radar.cta.label" :href="radar.cta.url" v-if="radar.cta && hasCta" margin="52px 0 0 0 " />
  </layout-block>
</template>

<script>
import LayoutBlock from '@/components/Layout/Block.vue'
import LayoutBlockSection from '@/components/Layout/Block/Section.vue'
import LayoutBlockSeparator from '@/components/Layout/Block/Separator.vue'
import LayoutBlockHead from '@/components/Layout/Block/Head.vue'
import LayoutBlockTitle from '@/components/Layout/Block/Title.vue'
import UiButton from '@/components/UI/Button.vue'

export default {
  name: 'ReportRadar',
  components: {
    LayoutBlock,
    LayoutBlockHead,
    LayoutBlockTitle,
    UiButton,
    LayoutBlockSection,
    LayoutBlockSeparator,
  },
  props: {
    radar: {
      type: Object,
      required: true,
    },
    hasCta: {
      type: Boolean,
      default: true,
    },
    separate: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
    width: {
      type: String,
      default: 'auto',
    },
  },
}
</script>
